import { BrowserRouter as Router } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import { HelmetProvider } from 'react-helmet-async'
import { AppProvider } from './context/AppContext'
import GoogleAnalytics from './components/common/GoogleAnalytics'
import GlobalStyles from './assets/styles/globalStyles'
import theme from './assets/styles/theme'
import AppRoutes from './routes'

/**
 * Composant principal de l'application
 * Version complète avec SEO, Analytics et gestion d'état globale
 */
function App() {
  return (
    <HelmetProvider>
      <AppProvider>
        <ThemeProvider theme={theme}>
          <GlobalStyles />
          <Router>
            <GoogleAnalytics measurementId="G-XXXXXXXXXX" />
            <AppRoutes />
          </Router>
        </ThemeProvider>
      </AppProvider>
    </HelmetProvider>
  )
}

export default App